@if (mappedAttachments!.length > 0) {
  <ion-item-group>
    @if (hasHeader) {
      <ion-item-divider class="ion-margin-top" mode="md">
        <ion-button color="medium" shape="round">
          <ion-icon name="attach-outline" slot="icon-only"/>
        </ion-button>
        <ion-text color="medium">
          <h2>{{ "COMPONENTS.ATTACHMENTS.FILES.LABEL" | translate }}</h2>
        </ion-text>
      </ion-item-divider>
    }
    @for (attachment of mappedAttachments; track attachment) {
      <!-- File: pdf/images-->
      @if (attachment.type === attachmentType.File) {
        <ion-item
          (click)="attachmentsService.dispatchAction(attachment)"
          [button]="true"
          [detail]="true"
          [disabled]="(attachmentsService.checkLoadingButton(attachment.loadingId) | async)"
          [lines]="lines"
        >
          @if (isIconFolderEnabled) {
            <ion-icon class="padding-left" name="document-attach" slot="start"/>
          }
          <ion-label>{{ attachment.name }}</ion-label>
          @if (!(attachmentsService.checkLoadingButton(attachment.loadingId) | async)) {
            <ion-badge
              color="primary"
              slot="end">
              {{ "COMPONENTS.ATTACHMENTS.FILES.TYPES.FILE" | translate }}
            </ion-badge>
          }
          @if ((attachmentsService.checkLoadingButton(attachment.loadingId) | async)) {
            <ion-spinner
              slot="end"/>
          }
        </ion-item>
      }
      <!-- Link-->
      @if (attachment.type === attachmentType.Link) {
        <ion-item
          (click)="attachmentsService.dispatchAction(attachment)"
          [button]="true"
          [detail]="true"
          [disabled]="(attachmentsService.checkLoadingButton(attachment.loadingId) | async)"
          [lines]="lines"
        >
          @if (isIconFolderEnabled) {
            <ion-icon class="padding-left" name="document-attach" slot="start"/>
          }
          <ion-label>{{ attachment.name }}</ion-label>
          @if (!(attachmentsService.checkLoadingButton(attachment.loadingId) | async)) {
            <ion-badge
              color="primary"
              slot="end">
              {{ "COMPONENTS.ATTACHMENTS.FILES.TYPES.LINK" | translate }}
            </ion-badge>
          }
          @if ((attachmentsService.checkLoadingButton(attachment.loadingId) | async)) {
            <ion-spinner
              slot="end"/>
          }
        </ion-item>
      }
      <!-- Knowledge-->
      @if (attachment.type === attachmentType.Knowledge) {
        <ion-item
          (click)="attachmentsService.dispatchAction(attachment)"
          [button]="true"
          [detail]="true"
          [disabled]="(attachmentsService.checkLoadingButton(attachment.loadingId) | async)"
          [lines]="lines"
        >
          @if (isIconFolderEnabled) {
            <ion-icon class="padding-left" name="document-attach" slot="start"/>
          }
          <ion-label>{{ attachment.name }}</ion-label>
          @if (!(attachmentsService.checkLoadingButton(attachment.loadingId) | async)) {
            <ion-badge
              color="primary"
              slot="end">
              {{ "COMPONENTS.ATTACHMENTS.FILES.TYPES.KNOWLEDGE" | translate }}
            </ion-badge>
          }
          @if ((attachmentsService.checkLoadingButton(attachment.loadingId) | async)) {
            <ion-spinner
              slot="end"/>
          }
        </ion-item>
      }
      <!-- Folder -->
      @if (attachment.type === attachmentType.Folder) {
        <ion-item
          (click)="attachmentsService.dispatchAction(attachment)"
          [button]="true"
          [detail]="true"
          [disabled]="(attachmentsService.checkLoadingButton(attachment.loadingId) | async) || (isLink$ | async)"
          [lines]="lines"
        >
          @if (isIconFolderEnabled) {
            <ion-icon class="padding-left" name="document" slot="start"/>
          }
          <ion-label>{{ attachment.path }}</ion-label>
          @if (!(attachmentsService.checkLoadingButton(attachment.loadingId) | async)) {
            <ion-badge
              color="primary"
              slot="end">
              {{ "COMPONENTS.ATTACHMENTS.FILES.TYPES.FOLDER" | translate }}
            </ion-badge>
          }
          @if ((attachmentsService.checkLoadingButton(attachment.loadingId) | async)) {
            <ion-spinner
              slot="end"/>
          }
        </ion-item>
      }
    }
  </ion-item-group>
}
